const matchMedia = globalThis.matchMedia;
export { matchMedia };